import { useMutation } from "@tanstack/react-query";
import {
  completeShopifyOAuthApi,
  getShopifyOauthUrlApi,
} from "../api/shopifyIntegrationApi";
import type { ChainId, IntegrationId } from "@KassaroAB/shared/types/ids";

export const useCompleteShopifyOAuthMutation = () => {
  return useMutation({
    mutationFn: (body: { code: string; shop: string; state: string }) =>
      completeShopifyOAuthApi(body),
  });
};

export const useGetShopifyOauthUrlMutation = () =>
  useMutation({
    mutationFn: ({
      chainId,
      shopDomain,
      integrationId,
    }: {
      chainId: ChainId;
      shopDomain: string;
      integrationId?: IntegrationId;
    }) => getShopifyOauthUrlApi(chainId, shopDomain, integrationId),
  });
